import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '../lib/utils';

interface FormSectionProps {
  title?: string;
  icon?: LucideIcon;
  children: ReactNode;
  className?: string;
}

/** A self-contained white card holding one group of form fields: header,
 * divider, then the fields. Sections stack with a gap rather than sharing a
 * single panel, so each step reads as its own card. */
export function FormSection({ title, icon: Icon, children, className }: FormSectionProps) {
  return (
    <section
      className={cn(
        'flex flex-col gap-4 rounded-md border border-border bg-card p-5 shadow-card',
        className,
      )}
    >
      {title ? (
        <header className="flex flex-col gap-2">
          <div className="flex items-center gap-2">
            {Icon ? <Icon className="size-5 shrink-0 text-primary" aria-hidden /> : null}
            <h2 className="text-section text-foreground">{title}</h2>
          </div>
          <div className="h-px bg-divider" aria-hidden />
        </header>
      ) : null}

      <div className="flex flex-col gap-4">{children}</div>
    </section>
  );
}
